import request from "@/util/request";
import { apiUrl } from "@/api/Url.js";

// 获取推荐列表
export function getRecommend(data) {
    return request(
        `${apiUrl}/api/v1/charhoo/charhoo-web/get/recommend`,
        "get",
        data
    );
}

// 获取搜索列表
export function searchPage(data) {
    return request(
        `${apiUrl}/api/v1/charhoo/charhoo-web/search`,
        "get",
        data
    );
}

// 获取网站总统计
export function getStatistics(data) {
    return request(
        `${apiUrl}/api/v1/charhoo/charhoo-web/statistics`,
        "get",
        data
    );
}

// 获取网站总统计
export function getStatisticsContent(data) {
    return request(
        `${apiUrl}/api/v1/charhoo/charhoo-web/statistics/content`,
        "get",
        data
    );
}